import benchmark_create from "$root/assets/images/create-dialog[preload]/benchmark-create.svg";
import benchmark_template from "$root/assets/images/create-dialog[preload]/benchmark-template.svg";
import market_view_custom from "$root/assets/images/create-dialog[preload]/market-view-custom.svg";
import market_view_expected from "$root/assets/images/create-dialog[preload]/market-view-expected.svg";
import market_view_under from "$root/assets/images/create-dialog[preload]/market-view-under.svg";
import portfolio_create from "$root/assets/images/create-dialog[preload]/portfolio-create.svg";
import portfolio_upload_quantities from "$root/assets/images/create-dialog[preload]/portfolio-upload-quantities.svg";
import portfolio_upload_weights from "$root/assets/images/create-dialog[preload]/portfolio-upload-weights.svg";
import universe_flat from "$root/assets/images/create-dialog[preload]/universe-flat.svg";
import universe_groups from "$root/assets/images/create-dialog[preload]/universe-groups.svg";
import CalendarDrawIcon from "$root/assets/images/glyphs[preload]/CalendarDrawIcon.svg";
import CloudCalculatingDrawIconAlt from "$root/assets/images/glyphs[preload]/CloudCalculatingDrawIconAlt.svg";
import CloudClaculatingDrawIcon from "$root/assets/images/glyphs[preload]/CloudClaculatingDrawIcon.svg";
import EmptyBox from "$root/assets/images/glyphs[preload]/EmptyBox.svg";
import InvalidBox from "$root/assets/images/glyphs[preload]/InvalidBox.svg";
import MonitorCalculatingDrawIcon from "$root/assets/images/glyphs[preload]/MonitorCalculatingDrawIcon.svg";
import MonitorErrorDrawIcon from "$root/assets/images/glyphs[preload]/MonitorErrorDrawIcon.svg";
import MonitorWithHourglass from "$root/assets/images/glyphs[preload]/MonitorWithHourglass.svg";
import MonitorWithHourglass2 from "$root/assets/images/glyphs[preload]/MonitorWithHourglass2.svg";
import MonitoringMetricsIcon from "$root/assets/images/glyphs[preload]/MonitoringMetricsIcon.svg";
import SadMachineDrawIcon from "$root/assets/images/glyphs[preload]/SadMachineDrawIcon.svg";
import TextDescriptionDrawIcon from "$root/assets/images/glyphs[preload]/TextDescriptionDrawIcon.svg";
import WorldMap from "$root/assets/images/hmm[preload]/WorldMap.svg";
import custom from "$root/assets/images/market-view-settings[preload]/custom.png";
import expected from "$root/assets/images/market-view-settings[preload]/expected.png";
import under_over from "$root/assets/images/market-view-settings[preload]/under-over.png";
import LegendExpectedReturns from "$root/assets/images/outlook[preload]/LegendExpectedReturns.svg";

export const preloadList = [
	{ type: "image", url: benchmark_create },
	{ type: "image", url: benchmark_template },
	{ type: "image", url: market_view_custom },
	{ type: "image", url: market_view_expected },
	{ type: "image", url: market_view_under },
	{ type: "image", url: portfolio_create },
	{ type: "image", url: portfolio_upload_quantities },
	{ type: "image", url: portfolio_upload_weights },
	{ type: "image", url: universe_flat },
	{ type: "image", url: universe_groups },
	{ type: "image", url: CalendarDrawIcon },
	{ type: "image", url: CloudCalculatingDrawIconAlt },
	{ type: "image", url: CloudClaculatingDrawIcon },
	{ type: "image", url: EmptyBox },
	{ type: "image", url: InvalidBox },
	{ type: "image", url: MonitorCalculatingDrawIcon },
	{ type: "image", url: MonitorErrorDrawIcon },
	{ type: "image", url: MonitorWithHourglass },
	{ type: "image", url: MonitorWithHourglass2 },
	{ type: "image", url: MonitoringMetricsIcon },
	{ type: "image", url: SadMachineDrawIcon },
	{ type: "image", url: TextDescriptionDrawIcon },
	{ type: "image", url: WorldMap },
	{ type: "image", url: custom },
	{ type: "image", url: expected },
	{ type: "image", url: under_over },
	{ type: "image", url: LegendExpectedReturns },
];
